import { Alert, FormControl, FormControlLabel, FormHelperText, Stack, Switch } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useUpdateWorkflowRestriction, useWorkflowRestriction } from './useWorkflowRestriction'

type Props = {
  recordId: string
}

/** Saves on every flip, apart from the dialog's per-tab Save. */
export const WorkflowRestrictionToggle = ({ recordId }: Props) => {
  const { t } = useTranslation('settings', { keyPrefix: 'record-access' })
  const { data, isError: loadFailed } = useWorkflowRestriction(recordId)
  const restrictionUpdate = useUpdateWorkflowRestriction(recordId)

  // An unread switch would show the workflow as open, which it may not be.
  if (loadFailed && data == null) return <Alert severity="error">{t('restriction.load-error')}</Alert>

  const isRestricted = restrictionUpdate.isPending ? restrictionUpdate.variables : (data?.isRestricted ?? false)

  return (
    <Stack gap={1}>
      <FormControl fullWidth disabled={data == null || restrictionUpdate.isPending}>
        <FormControlLabel
          label={t('restriction.label')}
          labelPlacement="start"
          sx={{ width: '100%', justifyContent: 'space-between' }}
          control={
            <Switch size="small" checked={isRestricted} onChange={(event) => restrictionUpdate.mutate(event.target.checked)} />
          }
        />
        <FormHelperText sx={{ mt: 1 }}>{t('restriction.helper')}</FormHelperText>
      </FormControl>
      {restrictionUpdate.isError && <Alert severity="error">{t('restriction.save-error')}</Alert>}
    </Stack>
  )
}
